module.exports = "<!--\r\nAuto-generated\r\nDo not edit!!!\r\n-->"


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/auth-callback/auth-callback.component.html
// module id = ../../../../../src/app/auth-callback/auth-callback.component.html
// module chunks = main